/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeReaction.defs.js'
export { main as default } from './removeReaction.defs.js'
